// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
/* eslint-disable no-alert, no-console */
const awsmobile = {
  'aws_project_region': 'ap-northeast-1',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:f04b54f8-b503-4f4d-8535-3f75ffdbb4c6',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_VbEVlIYqH',
  'aws_user_pools_web_client_id': '7qch31srmip1m61p27t0pn7o4k',
  'oauth': {},
  'aws_content_delivery_bucket': 'web.thinkss-kenkobus.net',
  'aws_content_delivery_bucket_region': 'ap-northeast-1',
  'aws_content_delivery_url': 'https://d15kkkqrna8ac7.cloudfront.net',
  'aws_dynamodb_all_tables_region': 'ap-northeast-1',
  'aws_dynamodb_table_schemas': [
    {
      'tableName': 'user_settings-prod',
      'region': 'ap-northeast-1'
    },
    {
      'tableName': 'user_daily_enquetes-prod',
      'region': 'ap-northeast-1'
    },
    {
      'tableName': 'user_body_compositions-prod',
      'region': 'ap-northeast-1'
    },
    {
      'tableName': 'user_groups-prod',
      'region': 'ap-northeast-1'
    },
    {
      'tableName': 'user_felica-prod',
      'region': 'ap-northeast-1'
    }
  ],
  'aws_cloud_logic_custom': [
    {
      'name': 'thinkss-kenkobus-api',
      'endpoint': 'https://2nriwokkkf.execute-api.ap-northeast-1.amazonaws.com/v1',
      'region': 'ap-northeast-1'
    }
  ]
}

export default awsmobile
